import classNames from 'classnames';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { resolvePaymentMethodRole } from './PaymentMethodRoles.functions';
import usePaymentMethodRoles from './PaymentMethodRoles.hook';
import { tPaymentMethodRoleBadgeProps } from './PaymentMethodRoles.types';
import './PaymentMethodRoles.styles.scss';

/**
 * RET-2027 — what a saved card pays, next to the card: «Tarjeta de tu plan», or
 * «Tarjeta predeterminada de tu cuenta» on a customer default that is not the
 * plan's card. Renders nothing for any other card, and nothing at all while billing
 * has not named a plan card.
 *
 * MO-5 (Fanny, 24-oct-2026): the plan's card and the account's default are one
 * card, «Tarjeta predeterminada». A customer default that is still another
 * card (inherited, until billing unifies them) gets no badge: two cards
 * called «predeterminada» is what the decision removes.
 */
export default function PaymentMethodRoleBadge(
  props: tPaymentMethodRoleBadgeProps,
): ReactElement | null {
  const { t } = useTranslation('settings/SubscriptionManager');
  const role = resolvePaymentMethodRole({
    roles: usePaymentMethodRoles(),
    paymentMethodId: props.paymentMethodId,
  });

  if (role !== 'plan') {
    return null;
  }

  return (
    <span
      className={classNames(
        'PaymentMethodRoleBadge',
        `PaymentMethodRoleBadge--${role}`,
      )}
      data-testid={`payment-method-role-${role}`}
    >
      {t(`page.PaymentMethodRoles.${role}`)}
    </span>
  );
}
